export default {
  title: `Como funciona o simulador SiSU do Pro?`,
  description: `Simule suas chances de conseguir a tão sonhada vaga na universidade pública! Utilize a sua nota do ENEM (nota será liberada dia 29/03). `,
  form: {
    title: `Preencha as informações`,
    options: ['Linguagens', 'Humanas', 'Natureza', 'Matemática', 'Redação']
  },
  labels_options: {
    title: `Onde você quer estudar?`,
    label_course: 'Curso',
    label_uf: 'Estado',
    label_modalidade: 'Modalidade de concorrência'
  }
}
